import { Static } from '@sinclair/typebox';
import { StringEnum } from '../utils/typebox';

export const ProviderSchema = StringEnum(
  ['mock', 'whatsapp', 'linkedin', 'google', 'outlook', 'imap', 'telegram', 'instagram', 'facebook'],
  {
    description: `The provider's of the Account.
    - \`mock\` is mock.
    - \`whatsapp\` is WhatsApp.
    - \`linkedin\` is LinkedIn.
    - \`instagram\` is Instagram.
    - \`facebook\` is Facebook.
    - \`google\` is Google.
    - \`outlook\` is Outlook.
    - \`telegram\` is Telegram.
    - \`imap\` is IMAP.`,
  },
);
export const OauthProviderSchema = StringEnum(['google', 'outlook'], {
  description: `The provider that use Oauth as authentication method.
    - \`google\` is Google.
    - \`outlook\` is Outlook.`,
});

export type Provider = Static<typeof ProviderSchema>;
export type OauthProvider = Static<typeof OauthProviderSchema>;

const OAUTH_PROVIDERS: readonly Provider[] = ['google', 'outlook'];

export function isOauthProvider(provider: Provider): provider is OauthProvider {
  return OAUTH_PROVIDERS.includes(provider);
}
